import type { ExplorationVolume } from '../../types/exploration';
import { buildNodeGroupOptions } from '../../lib/filters/buildCheckboxFilterOptions';
import FilterCheckboxList from './FilterCheckboxList';

export default function NodeGroupFilter({
  volumes,
  pendingNodeGroupFilters,
  setPendingNodeGroupFilters,
  globalSearchQuery = '',
  isDisclosureOpen = false,
}: {
  volumes: ExplorationVolume[];
  pendingNodeGroupFilters: string[];
  setPendingNodeGroupFilters: (filters: string[]) => void;
  globalSearchQuery?: string;
  isDisclosureOpen?: boolean;
}) {
  const options = buildNodeGroupOptions(volumes);

  const handleChange = (nodeGroup: string) => {
    if (pendingNodeGroupFilters.includes(nodeGroup)) {
      setPendingNodeGroupFilters(pendingNodeGroupFilters.filter((g) => g !== nodeGroup));
    } else {
      setPendingNodeGroupFilters([...pendingNodeGroupFilters, nodeGroup]);
    }
  };

  if (!options.length) return null;

  return (
    <FilterCheckboxList
      options={options}
      globalSearchQuery={globalSearchQuery}
      showSectionSearch
      isDisclosureOpen={isDisclosureOpen}
      isSelected={(key) => pendingNodeGroupFilters.includes(key)}
      onToggle={handleChange}
      tagVariant="node"
    />
  );
}

export function buildNodeGroupFilterOptions(volumes: ExplorationVolume[]) {
  return buildNodeGroupOptions(volumes);
}
